module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av408-276d94cf90c3d8bff862384b227e8c87.jpg";